<!-- FMEmpty.vue -->
<template>
  <div class="fm-empty">
    <div class="fm-empty-icon">{{ search ? '🔍' : '📂' }}</div>
    <p class="fm-empty-title">{{ search ? 'Sin resultados' : 'Carpeta vacía' }}</p>
    <p class="fm-empty-sub">{{ search ? `No se encontraron archivos para "${search}"` : 'Arrastra archivos aquí o usa el botón Subir' }}</p>
  </div>
</template>
<script>
export default { name: 'FMEmpty', props: { search: String } }
</script>
<style scoped>
.fm-empty {
  flex: 1; display: flex; flex-direction: column;
  align-items: center; justify-content: center;
  gap: 8px; padding: 60px 20px; color: var(--fm-text2);
	height: 100%;
}
.fm-empty-icon { font-size: 48px; opacity: 0.4; }
.fm-empty-title { font-size: 16px; font-weight: 600; color: var(--fm-text); }
.fm-empty-sub { font-size: 13px; text-align: center; max-width: 300px; }
</style>
